import React from "react";
import { Dialog, createStyles, makeStyles, Theme } from "@material-ui/core";

interface IFeedbackModalProps {
  isOpen: boolean;
  closeModal(): void;
}

export const FeedbackModal: React.FC<IFeedbackModalProps> = ({
  isOpen,
  closeModal,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      fullWidth
      maxWidth="md"
      className={classes.root}
    >
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdJeJJ5sbz_hiMGdUJ03PYCDGQUimA-Ug2AdK3E2NL8KG6jSA/viewform?embedded=true"
        width="640"
        height="1518"
        title="Feedback"
        className={classes.iframe}
      >
        Loading…
      </iframe>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    iframe: {
      border: 0,
    },
  })
);
